import type { MedicalRecordInput } from "@/lib/validations/medical-record";
import type { MedicalRecordDetails } from "@/hooks/useMedicalRecord";
import { isPetDeceased } from "@/lib/utils/pet-death";

type MedicalRecordPetDeathSnapshot = {
  death_date?: string | null;
  death_cause?: string | null;
  status?: { name?: string | null } | null;
};

/**
 * Converte dados da consulta do banco de dados para o formato MedicalRecordInput
 * usado pelo formulário
 */
export const convertMedicalRecordToFormData = (
  record: MedicalRecordDetails,
  pet?: MedicalRecordPetDeathSnapshot | null,
): Partial<MedicalRecordInput> => {
  const registerDeath = Boolean(pet && (isPetDeceased(pet) || pet.death_date));
  const formData: Partial<MedicalRecordInput> = {
    pet_id: record.pet_id,
    appointment_id: record.appointment_id || "",
    clinic_id: record.clinic_id,
    consultation_date: record.consultation_date
      ? new Date(record.consultation_date)
      : new Date(),
    chief_complaint: record.chief_complaint || "",
    history: record.history || "",
    behavior: record.behavior || "",
    diet: record.diet || "",
    environment: record.environment || "",
    weight: record.weight ?? undefined,
    temperature: record.temperature ?? undefined,
    heart_rate: record.heart_rate ?? undefined,
    respiratory_rate: record.respiratory_rate ?? undefined,
    mucous_membranes: record.mucous_membranes || "",
    capillary_refill_time: record.capillary_refill_time || "",
    hydration_status: record.hydration_status || "",
    lymph_nodes: record.lymph_nodes || "",
    cardiac_auscultation: record.cardiac_auscultation || "",
    respiratory_auscultation: record.respiratory_auscultation || "",
    abdominal_palpation: record.abdominal_palpation || "",
    locomotor_system: record.locomotor_system || "",
    skin_coat: record.skin_coat || "",
    other_systems: record.other_systems || "",
    presumptive_diagnosis: record.presumptive_diagnosis || "",
    definitive_diagnosis: record.definitive_diagnosis || "",
    treatment: record.treatment || "",
    follow_up_date: record.follow_up_date
      ? new Date(record.follow_up_date)
      : undefined,
    follow_up_notes: record.follow_up_notes || "",
    register_death: registerDeath,
    death_date: pet?.death_date ? new Date(`${pet.death_date}T00:00:00`) : undefined,
    death_cause: pet?.death_cause || "",
  };

  return formData;
};
